import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AIChatbot from "@/components/AIChatbot";
import { PageTransition } from "@/components/PageTransition";

const TeclyAI = () => {
  const navigate = useNavigate();

  // Keep the messages list scrolled to bottom when the iOS keyboard
  // appears/dismisses — the layout (100dvh) stays fixed, only the
  // inner messages area resizes.
  useEffect(() => {
    const handleResize = () => {
      const scrollables = document.querySelectorAll<HTMLElement>(
        '[data-tecly-ai-root="true"] [class*="overflow-y-auto"], [data-tecly-ai-root="true"] [data-radix-scroll-area-viewport]'
      );
      scrollables.forEach((el) => {
        el.scrollTop = el.scrollHeight;
      });
    };
    window.visualViewport?.addEventListener("resize", handleResize);
    return () => window.visualViewport?.removeEventListener("resize", handleResize);
  }, []);

  return (
    <PageTransition>
      <div data-tecly-ai-root="true">
        <AIChatbot onBack={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))} />
      </div>
    </PageTransition>
  );
};

export default TeclyAI;
